require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-shopify-plus-vs-demandware.json") })
        }
      }, "path---blog-shopify-plus-vs-demandware");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-shopify-plus-vs-demandware!./.cache/json/blog-shopify-plus-vs-demandware.json
// module id = 490
// module chunks = 231608221292675